import React from 'react'
import Form from "react-bootstrap/Form"
import PropTypes from 'prop-types'

import {Col} from "react-bootstrap"
import './InputDomicilio.css'

const InputDomicilioContribuyente = (props) => {
  const register = props.register

  return (
    <div className='input-domicilio'>
      <Form.Row>
        <Col md={6}>
          <Form.Group controlId={'calleContribuyente'}>
            <Form.Label>Calle</Form.Label>
            <Form.Control type="text"
              name={`calle`}
              placeholder={'Calle'}
              ref={register({required: false})}
              disabled={true}
            />
            <Form.Control.Feedback type="invalid">
              Debe ingresar la calle
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Row>
            <Col md={6} >
              <Form.Group controlId={'numeroContribuyente'}>
                <Form.Label>Número</Form.Label>
                <Form.Control type="text"
                  name={`numeroCalle`}
                  placeholder={'Número'}
                  ref={register({
                    required: false
                  })}
                  disabled={true}
                />
                <Form.Control.Feedback type="invalid">
                  Debe ingresar el numero de la calle
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId={'pisoContribuyente'}>
                <Form.Label>Piso</Form.Label>
                <Form.Control type="text"
                  name={`piso`}
                  placeholder={'Piso'}
                  disabled={true}
                  ref={register({required: false})}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId={'codigoPostalContribuyente'}>
                <Form.Label>CP</Form.Label>
                <Form.Control type="text"
                  name={`codigoPostal`}
                  placeholder={'CP'}
                  ref={register({required: false})}
                  disabled={true}
                />
              </Form.Group>
            </Col>
          </Form.Row>
        </Col>
      </Form.Row>
    </div>
  )
}

InputDomicilioContribuyente.propTypes = {
  register: PropTypes.func
}

export default InputDomicilioContribuyente
